import { ReactNode, memo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';

import jetsLogo from '@shared/assets/images/jets-logo-orange.svg';
import classes from './AppHeader.module.scss';

// a page to open is a real link, so right-click and cmd/ctrl-click work; anything else is a button
export type HeaderMenuOption = { key: string; label: string } & ({ to: string } | { onClick: () => void });

interface AppHeaderProps {
  appLogo: { src: string; alt: string };
  onLogoClick: () => void;
  search?: ReactNode;
  notifications?: ReactNode;
  user: { initials: string; name: string };
  userMenu: HeaderMenuOption[];
  onOpenSidebar: () => void;
}

const AppHeader = ({ appLogo, onLogoClick, search, notifications, user, userMenu, onOpenSidebar }: AppHeaderProps): JSX.Element => (
  <header className={classes.appHeader} data-app-header>
    <div className="bar">
      <button type="button" className="logos" onClick={onLogoClick} aria-label="Home">
        <img src={jetsLogo} className="jets" alt="Jets.com Logo" />
        <img src={appLogo.src} className="appLogo" alt={appLogo.alt} />
      </button>
      <div className="middle">
        {search}
        {notifications}
        <Button fillMode="link" className="menuToggle" type="button" aria-label="Open menu" onClick={onOpenSidebar} />
      </div>
      <div className="user">
        <Button fillMode="outline" className="userToggle" type="button">
          <span className="initials">{user.initials}</span>
          <strong className="userName">{user.name}</strong>
        </Button>
        <ul className="userMenu">
          {userMenu.map((option) => (
            <li key={option.key}>
              {'to' in option
                ? <Link to={option.to}>{option.label}</Link>
                : <button type="button" onClick={option.onClick}>{option.label}</button>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  </header>
);

export default memo(AppHeader);
